import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const calendarEasterEgg2025: IPixelMapDay = {
	status: 'good',
	title: "Twenty Twenty-Five: The Good Year",
	icon: "mood",
	reason: `
		2025 was one hell of a year. It was a pivotal year and it was a crucial year where several chapters of my “old” life ended and my “new” life began. I started the year with my family and, as always, I made 1 simple wish:

		> To excel in everything that I do.

		I always make vague wishes of what I expect of the year to come. In 2022, I wished for a meaningful struggle, and I got it.	In 2023, though, I *expected* a wholesome year, but didn't actually	get it. For 2024, I didn't make a wish. But for 2025, I felt like I just had to make a wish, and that was to excel in everything I do.

		And excel I pretty much did.

		I got a job old me could only DREAM about (with a matching salary, too), I had new coworkers whom I worked well with, and I had a really good change of environment and headspace that made me feel like I was moving forward in my life. I actually was moving forward with my life, though. I was excelling, I was doing well.

		The trend kept up and, for the first half, my life went on as usual. Sure, I was lonely, but I was in this new environment to actually be with people. I was working hybrid now, and I had given up my old job that was fully remote. Working hybrid meant that I would be exposed to a new set of challenges and I tried my best to overcome them. Even though 2025 was a “good” year, it still had the usual challenges that made any year difficult: family issues and one more.

		Once I was done with half of the year, after a long day at work, I made a wish.

		> I wish for someone to come back into my life, AND I would keep everything from my new life.

		The next day, a surprise happened: someone actually did come back into my life. My wish actually came true. After having been gone for 8 months, I never expected them to actually reach out. But they did. And just like 2024, they became a staple of my everyday.

		My relationship with someone had matured at this point and we were just platonic. There were times when I wondered if I still had feelings for them, but when I gave myself time to sit with that question, my answer was always no. Emotionally, I've moved on from them. Having them come back after I've flourished in my life without them has shown me that I have the potential for a better life without them. Some of our habits carried on, like me staying up sometimes to accompany them, and some of our arguments. They also relied on me a lot this year compared to this others, which was one of my main stressors this year. But, as with everything that happened this year, I was somehow able to endure it without falling apart at the seams.

		This year was a good year, honestly. I'm not sure if it was better than 2021, but it's comparable. I had everything good happen to me this year: playing video games with friends; laughing and sharing stories and funny memes on Discord; hanging out with a lot of friends and people I know; and I even had new experiences that I've never had before. 2025 was truly a good year and I hope that 2026 would be even better.
	`,
	spotify: {
		song: "Forever",
		album: "DRIP",
		artist: "BABYMONSTER",
		link: "https://open.spotify.com/track/6b6KXDbDn0s0Jepxm8a3nr?si=9ca8419163684a58"
	},
	resonatedLyrics: [
		"Baby, it was all a dream, you thought I was yours",
		"멋대로 착각하지는 마",
		"It's bitter, it's sweet (oh), 저 하늘 높이",
		"I'm spreading my wings like I'ma live",
		"Forever (forever-ever-ever)",
		"Forever (forever, forever, forever-ever-ever)",
		"Forever",
		"Like I'm gonna live, like I'm gonna live forever",
	]
};

export default calendarEasterEgg2025;
